import { from } from "rxjs";
import { actionPlayerInfoAddBuffs, actionPlayerInfoRemoveBuffs, } from "../../info/player/actionPlayerInfo";
import { actionSubscriptionInfoUpdate } from "../../info/subscription/actionSubscriptionInfo";
export var networkNoticeSubscriptionUpdateHandler = function (action$, state$, deps) { return function (res) {
    var actions = [];
    if (res.changedSubscription) {
        res.changedSubscription.forEach(function (value) {
            if (value.addBuffs && value.addBuffs.length > 0) {
                actions.push(actionPlayerInfoAddBuffs(value.addBuffs));
            }
            if (value.removeBuffs && value.removeBuffs.length > 0) {
                actions.push(actionPlayerInfoRemoveBuffs(value.removeBuffs));
            }
        });
    }
    return from([actionSubscriptionInfoUpdate(res)].concat(actions));
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/network/handlers/networkNoticeSubscriptionUpdateHandler.ts
// module id = 2017
// module chunks = 3